export function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/utils/is-leap-year.js
// module id = 82
// module chunks = 0